import * as _ from 'lodash';
import * as cnsts from './AutocodeConstants';
// eslint-disable-next-line import/no-cycle
import { combineAllChildren, getShowTimePeriod } from './AutocodeFunctions';

const LEFT_PAREN = true;
const RIGHT_PAREN = false;

export const ACStandardLabels = props => {
  const { node } = props;
  const defaultVal = () => '';
  const drawDictionEntry = epstr => {
    return epstr;
  };

  const drawDefinitionEntry = () => {
    return node.data.title;
  };

  const drawOperator = () => {
    return ` ${node.data.type.label} `;
  };

  const drawParen = whichParen => {
    return whichParen === LEFT_PAREN ? ' (' : ') ';
  };

  return {
    defaultVal,
    drawDictionEntry,
    drawDefinitionEntry,
    drawOperator,
    drawParen,
  };
};

const AutocodeLabelsGenerator = (labelParts, extraStuff) => {
  // ****************************************************************************
  const toLabelString = (
    topNode,
    pToShow = {
      showCat: true,
      showSCats: true,
      showQ: true,
      showA: true,
    },
    showOriginalLabel = false
  ) => {
    const buildString = (node, pts) => {
      const getOperator = node => {
        // return ` ${node.data.type.label} `;
        return labelParts({ node, extraStuff }).drawOperator();
      };

      const getEndPoint = (node, pts, showAFlag, showTimePeriod) => {
        switch (node.type) {
          default:
            return labelParts({ node, extraStuff }).defaultVal();
          case cnsts.AC_NODETYPE_DEFINITION: {
            return labelParts({ node, extraStuff }).drawDefinitionEntry();
          }
          case cnsts.AC_NODETYPE_DATAPOINT: {
            let q = '';
            let a = '';
            let cat = '';
            let subCats = '';

            if (node.data.labels) {
              switch (node.data.labels.length) {
                case 0: {
                  // should never happen
                  q = 'error';
                  a = 'error';
                  cat = 'error';
                  break;
                }
                case 1: {
                  // a = getAnswerForLevel(node.data, 0, showTimePeriod);
                  a = node.data.labels[0];
                  break;
                }
                case 2: {
                  q = node.data.labels[0];
                  // a = getAnswerForLevel(node.data, 1, showTimePeriod);
                  a = node.data.labels[1];
                  break;
                }
                case 3: {
                  cat = node.data.labels[0];
                  q = node.data.labels[1];
                  // a = getAnswerForLevel(node.data, 2, showTimePeriod);
                  a = node.data.labels[2];
                  break;
                }
                default: {
                  // >3
                  const cats = _.dropRight(_.drop(node.data.labels, 1), 2);
                  cat = pts.showCat ? cats[0] : '';

                  if (cats.length >= 2) {
                    subCats = pts.showSCats
                      ? _.join(_.drop(_.split(cats, ',')), '/')
                      : '';
                  }
                  q = node.data.labels[node.data.labels.length - 2];
                  // a = getAnswerForLevel(
                  //   node.data,
                  //   node.data.labels.length - 1,
                  //   showTimePeriod
                  // );
                  a = node.data.labels[node.data.labels.length - 1];
                  break;
                }
              }
            }

            let epstr = pts.showCat ? cat : '';
            let lastCharIsSpecialCharFlag = false;
            if (epstr.length > 0) {
              epstr += ': ';
              lastCharIsSpecialCharFlag = true;
            } else {
              epstr += '';
            }
            epstr += subCats;
            lastCharIsSpecialCharFlag =
              pts.showSCats && subCats.length > 0
                ? false
                : lastCharIsSpecialCharFlag;

            if (!lastCharIsSpecialCharFlag && pts.showQ && epstr.length > 0) {
              epstr += '/ ';
              lastCharIsSpecialCharFlag = true;
            } else {
              epstr += '';
            }
            epstr += pts.showQ ? q : '';
            lastCharIsSpecialCharFlag =
              pts.showQ && q.length > 0 ? false : lastCharIsSpecialCharFlag;
            epstr +=
              !lastCharIsSpecialCharFlag && epstr.length > 0 && pts.showA
                ? '_'
                : '';
            epstr += pts.showA ? a : '';

            if (showAFlag === undefined && subCats.length === 0) {
              epstr = epstr.length === 0 ? a : epstr; // if the string contains no text then display answer
            }

            return labelParts({ node, extraStuff }).drawDictionEntry(epstr);
          }
        }
      };

      const getCatToQuestion = (node, pts) => {
        let showAFlag = false;
        if (!pts.showCat && !pts.showQ && pts.showA && pts.showSCats) {
          showAFlag = pts.showA;
        }
        return node && node.type !== cnsts.AC_NODETYPE_OPERATOR
          ? getEndPoint(node, { ...pts, showA: false }, showAFlag)
          : node && getCatToQuestion(node.children[0], pts);
      };

      const buildMerged = node => {
        let bmstr = '';
        const merge = node => {
          if (node.type === cnsts.AC_NODETYPE_OPERATOR) {
            // bmstr += labelParts({ node, extraStuff }).drawParen(LEFT_PAREN);
            if (node.children[0]) {
              merge(node.children[0]);
            }
            bmstr += getOperator(node);
            if (node.children[1]) {
              merge(node.children[1]);
            }
            // bmstr += labelParts({ node, extraStuff }).drawParen(RIGHT_PAREN);
          } else {
            const p = {
              showCat: false,
              showSCats: false,
              showQ: false,
              showA: true,
            };
            bmstr += getEndPoint(node, p);
          }
        };

        bmstr += getCatToQuestion(node, pts);
        bmstr += labelParts({ node, extraStuff }).drawParen(LEFT_PAREN);
        merge(node);
        bmstr += labelParts({ node, extraStuff }).drawParen(RIGHT_PAREN);
        return bmstr;
      };

      const buildIndividual = (
        node,
        pts = {
          showCat: true,
          showSCats: true,
          showQ: true,
          showA: true,
        }
      ) => {
        let bistr = '';
        const genOutput = (node, pts) => {
          switch (node.type) {
            case cnsts.AC_NODETYPE_OPERATOR: {
              // if (node.combine() === false) {
              if (!combineAllChildren(node)) {
                genOutput(node.children[0], pts);
                bistr += getOperator(node);
                genOutput(node.children[1], pts);
              } else bistr += buildMerged(node, pts);
              break;
            }
            case cnsts.AC_NODETYPE_FUNC: {
              // eslint-disable-next-line no-use-before-define
              bistr += buildLabel(node, pts);
              break;
            }
            default: {
              bistr += labelParts({ node, extraStuff }).drawParen(LEFT_PAREN);
              bistr += getEndPoint(node, pts);
              bistr += labelParts({ node, extraStuff }).drawParen(RIGHT_PAREN);
              break;
            }
          }
        };

        bistr += labelParts({ node, extraStuff }).drawParen(LEFT_PAREN);
        genOutput(node, pts);
        bistr += labelParts({ node, extraStuff }).drawParen(RIGHT_PAREN);
        return bistr;
      };

      const buildFunctionSuffix = node => {
        switch (_.upperCase(node.data.funcName)) {
          default:
            return '';
          case 'COUNT':
            return `; ${node.data.params.lower}-${node.data.params.upper}`;
        }
      };

      const buildFunctionLabel = (node, pts) => {
        let funcStr = '';
        const showTimePeriod = getShowTimePeriod(node.data.funcName);
        funcStr += node.data.funcName;
        funcStr += labelParts({ node, extraStuff }).drawParen(LEFT_PAREN);
        node.children.forEach(n => {
          switch (n.type) {
            case cnsts.AC_NODETYPE_OPERATOR: {
              funcStr += combineAllChildren(n)
                ? buildMerged(n)
                : buildIndividual(n, pts);
              // n.combine() === true ? buildMerged(n) : buildIndividual(n, pts);

              break;
            }
            case cnsts.AC_NODETYPE_DATAPOINT:
            case cnsts.AC_NODETYPE_DEFINITION: {
              funcStr += getEndPoint(n, pts, undefined, showTimePeriod);
              break;
            }
            case cnsts.AC_NODETYPE_FUNC:
              funcStr += buildFunctionLabel(n, pts);
              break;
            default:
              funcStr += '';
              break;
          }
        });
        funcStr += buildFunctionSuffix(node);
        funcStr += labelParts({ node, extraStuff }).drawParen(RIGHT_PAREN);
        return funcStr;
      };

      const buildLabel = (node, pts) => {
        let outstr = '';
        switch (node.type) {
          case cnsts.AC_NODETYPE_OPERATOR: {
            outstr += combineAllChildren(node)
              ? buildMerged(node)
              : buildIndividual(node, pts);
            // node.combine() === true ? buildMerged(node) : buildIndividual(node, pts);
            break;
          }
          case cnsts.AC_NODETYPE_DATAPOINT:
          case cnsts.AC_NODETYPE_DEFINITION: {
            outstr += getEndPoint(node, pts);
            break;
          }
          case cnsts.AC_NODETYPE_FUNC:
            outstr += buildFunctionLabel(node, pts);
            break;
          default:
            outstr += '';
            break;
        }
        return outstr;
      };

      return buildLabel(node, pts);
    };

    return topNode.useLabelOverride && !showOriginalLabel
      ? topNode.labelOverride
      : buildString(topNode, pToShow);
  };

  // ****************************************************************************
  // ****************************************************************************
  // ****************************************************************************
  const toDefString = node => {
    let outstr = '';

    const funcDefs = (node, funcAdded) => {
      const lcase = _.upperCase(node.data.funcName);
      switch (lcase) {
        default: {
          /* // this if condition is specific to the import spc as we need some keyword/expression to
             // get the functionName for the sampleweighted call */
          if (node.data.noFuncKeyword) {
            outstr = `${node.data.noFuncKeyword}`;
          }
          break;
        }
        case 'NET ANY': {
          outstr += 'NETANY(';
          let operator = '';
          if (node.data.params && node.data.params.operator) {
            operator = node.data.params.operator.label;
          } else if (node.data.operator) {
            operator = node.data.operator.label;
          }

          node.children.forEach((n, i) => {
            outstr += i !== 0 ? ` ${operator} ` : '';
            // eslint-disable-next-line no-use-before-define
            netAnydefs(n, false, true);
          });
          outstr += ')';
          break;
        }
        case 'COUNT': {
          outstr += 'COUNTRANGE(';
          node.children.forEach((n, i) => {
            outstr += i !== 0 ? ' , ' : '';
            // For Count func, use funcAdded false
            // so expressions within are generated as is (not in KW, MP format)
            // eslint-disable-next-line no-use-before-define
            defs(n, false, false);
          });
          outstr += `,${node.data.params.lower},${node.data.params.upper})`;
          break;
        }
        case 'NOT':
          outstr += 'NOT (';
          node.children.forEach((n, i) => {
            outstr += i !== 0 ? ' , ' : '';
            // eslint-disable-next-line no-use-before-define
            defs(n, false, false);
          });
          outstr += ' ) ';
          break;
        case 'SUM':
          outstr += '(';
          node.children // should only be datapoints, SUMS and VOLS
            .forEach((n, i) => {
              outstr += i !== 0 ? ' + ' : '';
              // eslint-disable-next-line no-use-before-define
              defs(n, false, false);
            });
          outstr += ' ) ';
          break;
        case 'MEDIAN':
        case 'MEAN VOL':
        case 'MEDIAN VOL':
        case 'MEDIANDISCRETE':
        case 'MEDIANDISCRETENOZERO':
        case 'MEDIANNOZERO':
        case 'MEANSCORENOZERO':
        case 'MEANSCORE':
        case 'MEAN':
        case 'VOL': {
          /*
           How volume fn is written out depends on datapoint type.
           A mix of numeric and non-numeric datapoints might be rare use case.
           If it happens non-numerics will be written out first, then numerics after separated with '+'.
           ex: MEAN( VOLUME (NONNUMERIC1, 0, NONNUMERIC2, 0) + (NUMERIC1 + NUMERIC2))
          */

          // Seperate numeric and non-numeric datapoints
          let numerics = node.children.filter(
            node =>
              node.data.datatype === 'N' &&
              node.type === cnsts.AC_NODETYPE_DATAPOINT
          );
          const nonNumerics = node.children.filter(
            node =>
              node.data.datatype !== 'N' ||
              node.type !== cnsts.AC_NODETYPE_DATAPOINT
          );

          // Write out opening function
          switch (lcase) {
            default:
              outstr += `${lcase} (`;
              break;
            case 'VOL':
              outstr += ' ( ';
              break;
            case 'MEAN VOL':
              outstr += numerics.length === 0 ? 'MEAN ( ' : 'MEANNOZERO ( ';
              break;
            case 'MEDIAN VOL':
              outstr += 'MEDIANNOZERO ( ';
              break;
            case 'MEAN':
              // Handle template 4 MEAN fn as special case
              if (
                numerics.every(n => n.data.template === cnsts.TEMPLATE_TYPE_4)
              ) {
                // If at least one numeric datapoint contains 1+ users suffix ...
                if (
                  numerics.some(n =>
                    n.data.keyword.includes(cnsts.AC_1_PLUS_USERS_SUFFIX)
                  )
                ) {
                  // ... remove 1+ users suffix from keywords...
                  numerics = numerics.map(n => ({
                    ...n,
                    data: {
                      ...n.data,
                      keyword: n.data.keyword.replace(
                        cnsts.AC_1_PLUS_USERS_SUFFIX,
                        ''
                      ),
                    },
                  }));
                  // ... and use MEANNOZERO fn
                  outstr += 'MEANNOZERO (';
                } else {
                  // Use MEAN fn for datapoints without 1+users
                  outstr += 'MEAN (';
                }
              } else {
                // All other templates use MEANNOZER
                outstr += 'MEANNOZERO (';
              }
              break;
            case 'MEDIAN':
              outstr += 'MEDIANNOZERO (';
              break;
          }

          // Wrap non-numerics in VOLUME fn with midpoints
          if (nonNumerics.length > 0) {
            outstr += ' VOLUME (';
            nonNumerics.forEach((n, i) => {
              outstr += i !== 0 ? ' , ' : '';
              // eslint-disable-next-line no-use-before-define
              defs(n, true, funcAdded, n.data.volKeyword); // if volKeyword exists use that in output
            });
            outstr += ')';

            // if numerics exist append after non-numerics with +
            if (numerics.length > 0) outstr += ' + ';
          }

          // Write out numerics separated with +
          if (numerics.length > 0) {
            outstr += '(';
            numerics.forEach((n, i) => {
              outstr += i !== 0 ? ' + ' : '';
              outstr += '(';
              // eslint-disable-next-line no-use-before-define
              defs(n, false, false, n.data.volKeyword); // if volKeyword exists use that in output
              outstr += ')';
            });
            outstr += ')';
          }

          outstr += ')';
          break;
        }
        case 'ntile': {
          break;
        }
        case 'ntilewt': {
          break;
        }
      }
    };

    const defs = (node, showMP, funcAdded, useVolKeyword) => {
      switch (node.type) {
        default:
          outstr += '';
          break;
        case cnsts.AC_NODETYPE_OPERATOR: {
          outstr += !funcAdded ? '(' : '';
          // if (node.combine()) {
          if (combineAllChildren(node)) {
            // I'm not sure why we need this here
            defs(node.children[0], showMP, funcAdded); // funcAdded was missing (I needed it here.)
            outstr += !funcAdded ? ` ${node.data.type.symbol} ` : ` , `;
            defs(node.children[1], showMP, funcAdded);
          } else {
            defs(node.children[0], showMP, funcAdded);
            outstr += !funcAdded ? ` ${node.data.type.symbol} ` : ` , `;
            defs(node.children[1], showMP, funcAdded);
          }
          outstr += !funcAdded ? ')' : '';
          break;
        }
        case cnsts.AC_NODETYPE_DATAPOINT: {
          // output volKeyword instead of keyword when useVolKeyword is true
          outstr += `${
            useVolKeyword ? node.data.volKeyword : node.data.keyword
          } ${
            showMP && !useVolKeyword // don't show MP is useVolKeyword is true
              ? `, ${node.data.midpoint ? node.data.midpoint : 0}`
              : ''
          }`;
          break;
        }
        case cnsts.AC_NODETYPE_DEFINITION: {
          outstr += node.data.expression;
          break;
        }
        case cnsts.AC_NODETYPE_FUNC: {
          funcDefs(node, funcAdded);
          break;
        }
      }
      return outstr;
    };

    const netAnydefs = (node, showMP, funcAdded) => {
      const lcase = _.upperCase(node.data.funcName);
      switch (node.type) {
        default:
          outstr += '';
          break;
        case cnsts.AC_NODETYPE_OPERATOR: {
          if (
            node.children[0].type === cnsts.AC_NODETYPE_OPERATOR &&
            node.children[1].type !== cnsts.AC_NODETYPE_OPERATOR
          ) {
            outstr += funcAdded ? '(' : '';
            netAnydefs(node.children[0], false, true);
            outstr += funcAdded ? ` ${node.data.type.symbol} ` : ` , `;
            outstr += `${node.children[1].data.keyword}`;
            outstr += funcAdded ? ')' : '';
          }
          if (
            node.children[1].type === cnsts.AC_NODETYPE_OPERATOR &&
            node.children[0].type !== cnsts.AC_NODETYPE_OPERATOR
          ) {
            outstr += funcAdded ? '(' : '';
            outstr += `${node.children[0].data.keyword}`;
            outstr += funcAdded ? ` ${node.data.type.symbol} ` : ` , `;
            netAnydefs(node.children[1], false, true);
            outstr += funcAdded ? ')' : '';
          }
          if (
            node.children[1].type === cnsts.AC_NODETYPE_OPERATOR &&
            node.children[0].type === cnsts.AC_NODETYPE_OPERATOR
          ) {
            netAnydefs(node.children[0], false, true);
            outstr += funcAdded ? ` ${node.data.type.symbol} ` : ` , `;
            netAnydefs(node.children[1], false, true);
          }
          if (
            node.children[0].type !== cnsts.AC_NODETYPE_OPERATOR &&
            node.children[1].type !== cnsts.AC_NODETYPE_OPERATOR
          ) {
            outstr += funcAdded ? '(' : '';
            // if (node.combine()) {
            if (combineAllChildren(node)) {
              netAnydefs(node.children[0], showMP);
              outstr += funcAdded ? ` ${node.data.type.symbol} ` : ` , `;
              netAnydefs(node.children[1], showMP, funcAdded);
            } else {
              netAnydefs(node.children[0], showMP, funcAdded);
              outstr += funcAdded ? ` ${node.data.type.symbol} ` : ` , `;
              netAnydefs(node.children[1], showMP, funcAdded);
            }
            outstr += funcAdded ? ')' : '';
          }
          break;
        }
        case cnsts.AC_NODETYPE_DATAPOINT: {
          outstr += `${node.data.keyword} ${
            showMP ? `, ${node.data.midpoint ? node.data.midpoint : 0}` : ''
          }`;
          break;
        }
        case cnsts.AC_NODETYPE_DEFINITION: {
          outstr += node.data.expression;
          break;
        }
        case cnsts.AC_NODETYPE_FUNC: {
          if (lcase === 'NET ANY') {
            netAnydefs(node, funcAdded);
          } else {
            funcDefs(node, funcAdded);
          }

          break;
        }
      }
      return outstr;
    };

    return `( ${defs(node, false, node.type === cnsts.AC_NODETYPE_FUNC)} )`;
  };

  return { toLabelString, toDefString };
};

export default AutocodeLabelsGenerator;
